export const ACCOUNT_CHANGE_PASSWORD_OPEN_MODAL = "ACCOUNT_CHANGE_PASSWORD_OPEN_MODAL";
export const ACCOUNT_CHANGE_PASSWORD_SET_PASSWORD = "ACCOUNT_CHANGE_PASSWORD_SET_PASSWORD";
export const ACCOUNT_CHANGE_PASSWORD_SET_PASSWORD_RESULT = "ACCOUNT_CHANGE_PASSWORD_SET_PASSWORD_RESULT";